import { Line } from 'react-konva'
import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { commonShapeProps, ShapeInteraction } from './shapeInteraction'

type Props = {
  shape: Extract<VisualShape, { type: 'pencil' }>
  width: number
  height: number
  interaction?: ShapeInteraction
}

const PencilShape = ({ shape, width, height, interaction }: Props) => {
  const centerX = shape.x * width
  const centerY = shape.y * height
  const pixelPoints = shape.points.map((point, i) =>
    i % 2 === 0 ? point * width : point * height,
  )

  return (
    <Line
      ref={interaction?.nodeRef}
      x={centerX}
      y={centerY}
      points={pixelPoints}
      rotation={shape.rotation ?? 0}
      lineCap='round'
      lineJoin='round'
      hitStrokeWidth={interaction ? 20 : undefined}
      {...commonShapeProps(shape)}
      draggable={interaction?.draggable ?? false}
      listening={interaction !== undefined}
      onMouseEnter={interaction?.onMouseEnter}
      onMouseLeave={interaction?.onMouseLeave}
      onMouseDown={interaction?.onMouseDown}
      onTap={interaction?.onTap}
      onDragStart={interaction?.onDragStart}
      onDragMove={interaction?.onDragMove}
      onDragEnd={interaction?.onDragEnd}
    />
  )
}

export default PencilShape
